import axios from 'axios'
import { axiosConfig } from '../../config/axiosConfig.js'

export function get_short_term_precp_datetime_ajax(client_name) {
    const param = { 
        'tag_id': 248,
        // 'tag_name': '短延時強降雨', 
        'group': client_name 
    }
    return axios.post(`${client_name}/rainmonitor/get_tag_sectiondisplay_data_time_by_tag/`, param, axiosConfig)
}

export const get_short_term_precp_ajax = (client_name, datetime) => {
    const param = {
        params: {
            group: client_name,
            data_time: datetime
        }
    }
    return axios.get(`${client_name}/rainmonitor/get_short_rain_notify/`, {...param, ...axiosConfig})
}